import { render, staticRenderFns } from "./modalDetailPK.vue?vue&type=template&id=2403cc76&scoped=true"
import script from "./modalDetailPK.vue?vue&type=script&lang=js"
export * from "./modalDetailPK.vue?vue&type=script&lang=js"
import style0 from "./modalDetailPK.vue?vue&type=style&index=0&id=2403cc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2403cc76",
  null
  
)

export default component.exports